var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftformitem"},[_c('div',{staticClass:"leftformtitle"},[_vm._v(_vm._s(_vm.property.name)),(_vm.property.checked)?_c('span',{staticClass:"ischeck"},[_vm._v("*")]):_vm._e()]),_vm._m(0),_c('i',{staticClass:"el-icon-arrow-down"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftformbd"},[_c('div',{staticClass:"leftforminput"},[_vm._v("yyyy/mm/d")])])
}]

export { render, staticRenderFns }